import type { InputHTMLAttributes, ReactNode } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  icon?: string;
  error?: string;
  hint?: ReactNode;
}

export default function Input({
  label,
  icon,
  error,
  hint,
  className = "",
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name;
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={inputId}
          className="block text-sm font-medium text-foreground-800 mb-1.5"
        >
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-500 pointer-events-none">
            <i className={`${icon} text-base`} />
          </span>
        )}
        <input
          id={inputId}
          className={`w-full rounded-md border bg-background-50 text-foreground-900 text-sm px-3 py-2.5 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400 ${
            icon ? "pl-10" : ""
          } ${
            error
              ? "border-red-400 focus:ring-red-400 focus:border-red-400"
              : "border-secondary-300"
          } ${className}`}
          {...props}
        />
      </div>
      {hint && !error && (
        <p className="mt-1 text-xs text-foreground-500">{hint}</p>
      )}
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}